export default __webpack_public_path__ + "static/wegift-blue.url-cfb528cfa8427194c885b6f25444665e.svg";